import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  root: {
    width: "100%",
    marginBottom: 50
  },
  textContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 50,
    marginBottom: 30,
    [theme.breakpoints.down("xs")]: {
      margin: "30px 15px"
    }
  },
  bannerContainer: {
    background: "#eeeded",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  paragraphContainer: {
    width: 350,
    marginRight: 100,
    [theme.breakpoints.down("xs")]: {
      marginRight: "15px",
      marginLeft: "15px",
      width: "100%"
    }
  },
  textParagraph: {
    fontSize: 22,
    color: "#525c64",
    fontFamily: "Trebuchet",
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
      textAlign: "center"
    }
  },
  imageContainer: {
    marginTop: 30,
    marginBottom: -4
  },
  titleStyle: {
    fontFamily: "Trebuchet",
    color: "#525c64",
    [theme.breakpoints.down("xs")]: {
      fontSize: "30px",
      textAlign: "center"
    }
  }
}));

export default styles;
